// extracted by css-extract-rspack-plugin
export default {"cls1":"YourPaperCard-cls1_1ia","cls2":"YourPaperCard-cls2_oUs YourPaperCard-cls1_1ia"};